export default __webpack_public_path__ + "static/media/coverimage.be6c4f27.jpg";